module.exports = __webpack_public_path__ + "img/review-success-en.8d6afa3d.png";